export const adminOffersColumns = [
  {
    column_name: 'Offer ID',
    column_value: 'id',
  },
  {
    column_name: 'Business Area',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Business Name',
    column_value: '',
  },
  {
    column_name: 'Trucker ID',
    column_value: 'trucker_id',
  },
  {
    column_name: 'Business Cluster',
    column_value: 'businessCluster',
    is_bold: true,
  },
  {
    column_name: 'Trading Name',
    column_value: 'trading_name',
  },
  {
    column_name: 'Owner Name',
    column_value: 'primary_fullname',
  },
  {
    column_name: 'Driver Name',
    column_value: 'driver_fullname',
  },
  {
    column_name: 'Truck No.',
    column_value: 'truck_number',
    is_bold: true,
  },
  {
    column_name: 'Owner Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Driver Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Tyres / Capacity Range',
    column_value: 'tyres',
    is_bold: true,
  },
  {
    column_name: 'Alt Name',
    column_value: 'alternative_fullname',
  },
  {
    column_name: 'Preferred Routes',
    column_value: '',
  },
  {
    column_name: 'Available Area',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Alt Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Pref. Materials / Products',
    column_value: '',
  },
  {
    column_name: 'Available Date',
    column_value: 'loading_date',
    is_bold: true,
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'Conditions',
    column_value: '',
  },
  {
    column_name: 'Offer Cluster',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'status',
  },
  {
    column_name: 'Visibility',
    column_value: 'is_public',
  },
  {
    column_name: 'Notes',
    column_value: '',
  },
  {
    column_name: 'Balance',
    column_value: 'available_balance',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: 'Remarks',
    column_value: 'remark',
    condition: (column_name: string, column_value: string) => column_name === 'Status' && column_value === 'Cancelled',
  },
]

export const usersOffersColumns = [
  {
    column_name: 'Offer ID',
    column_value: 'id',
  },
  {
    column_name: 'Business Area',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Business Name',
    column_value: '',
  },
  {
    column_name: 'Trucker ID',
    column_value: 'trucker_id',
  },
  {
    column_name: 'Business Cluster',
    column_value: 'businessCluster',
    is_bold: true,
  },
  {
    column_name: 'Trading Name',
    column_value: 'trading_name',
  },
  {
    column_name: 'Owner Name',
    column_value: 'primary_fullname',
  },
  {
    column_name: 'Driver Name',
    column_value: 'driver_fullname',
  },
  {
    column_name: 'Truck No.',
    column_value: 'truck_number',
    is_bold: true,
  },
  {
    column_name: 'Owner Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Driver Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Tyres / Capacity Range',
    column_value: 'tyres',
    is_bold: true,
  },
  {
    column_name: 'Alt Name',
    column_value: 'alternative_fullname',
  },
  {
    column_name: 'Preferred Routes',
    column_value: '',
  },
  {
    column_name: 'Available Area',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Alt Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Pref. Materials / Products',
    column_value: '',
  },
  {
    column_name: 'Available Date',
    column_value: 'loading_date',
    is_bold: true,
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'Conditions',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'status',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },

  {
    column_name: 'Notes',
    column_value: '',
  },
  {
    column_name: 'Remarks',
    column_value: 'remark',
    condition: (column_name: string, column_value: string) => column_name === 'Status' && column_value === 'Cancelled',
  },
]

export const offersBoldColumns = [
  'Offer Cluster',
  'Truck No',
  'Tyres',
  'Available Area',
]

export const truckerOfferCols = [
  { name: 'Trucker ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Address', value: 'address' },
  { name: 'Website', value: 'web' },
  { name: '', value: '' },
]

export const hybridOfferCols = [
  { name: 'Hybrid User ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Address', value: 'address' },
  { name: 'Website', value: 'web' },
  { name: '', value: '' },
]

export const offerSearchFields: any = reactive({
  id: '',
  primary_fullname: '',
  primary_preferred_contact: '',
  alternative_fullname: '',
  alternative_mobiles: '',
  driver_fullname: '',
  driver_preferred_contact: '',
  truck_number: '',
  cluster_place_name: '',
  tyres: null,
  loading_date: '',
  routes: '',
  material: '',
  conditions: '',
  status: null,
  remark: '',
  is_public: '',
  place_name: '',
})

export const resetOfferFields = { ...offerSearchFields }
